/*
 *
 * Home reducer
 *
 */
import { produce } from "immer";
import * as Types from "./constants";

export const initialState = {
  counterData: [],
};

/* eslint-disable default-case, no-param-reassign */
const homeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_COUNTER_REQUESTED:
        break;
      case Types.GET_COUNTER_SUCCESS:
        draft.counterData = action.payload;
        break;
      case Types.GET_COUNTER_FAILED:
        break;
      case Types.SET_VIEW_BANNER_REQUESTED:
        break;
      case Types.SET_VIEW_BANNER_SUCCESS:
        console.log(action.payload, "view response");

        // if (draft.counterData?.banner?.find((item) => item.id === action.payload.id)?.view_count)
        draft.counterData.banner.find(
          (item) => item.id === action.payload.id
        ).view_count = action.payload.view_count;

        break;
      case Types.SET_VIEW_BANNER_FAILED:
        break;
      default:
        break;
    }
  });

export default homeReducer;
